import { EMPTY_STRING } from '../../../constants/common'

export function getRequestTranslationToolbarTraceId() {
  if (window?.crypto?.randomUUID) {
    return window.crypto.randomUUID()
  }

  // RFC4122 UUID v4 without extra packages
  const bytes = new Uint8Array(16)

  if (window?.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes)
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256)
    }
  }

  // Set version (4) and variant (10)
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80

  const hex = Array.from(bytes, byte =>
    byte.toString(16).padStart(2, '0')
  ).join(EMPTY_STRING)

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(
    16,
    20
  )}-${hex.slice(20)}`
}
